var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_10x10_flag_photo",
    "data-name": "10x10 flag photo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4644",
    "data-name": "Rectangle 4644",
    width: 10,
    height: 10,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_273",
    "data-name": "Mask Group 273",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-14",
    transform: "translate(0.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21271",
    "data-name": "Path 21271",
    d: "M4.108,4.817a2.33,2.33,0,0,0,1.7-.706,2.33,2.33,0,0,0,.706-1.7,2.331,2.331,0,0,0-.706-1.7A2.331,2.331,0,0,0,4.108,0a2.33,2.33,0,0,0-1.7.706,2.331,2.331,0,0,0-.706,1.7,2.33,2.33,0,0,0,.706,1.7A2.331,2.331,0,0,0,4.108,4.817Zm0,0",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21272",
    "data-name": "Path 21272",
    d: "M8.323,7.689a5.949,5.949,0,0,0-.081-.632,4.978,4.978,0,0,0-.155-.635,3.138,3.138,0,0,0-.261-.592,2.236,2.236,0,0,0-.394-.513,1.736,1.736,0,0,0-.566-.355,1.955,1.955,0,0,0-.722-.131A.733.733,0,0,0,5.752,5l-.408.263a2.337,2.337,0,0,1-.528.232,2.049,2.049,0,0,1-1.291,0A2.331,2.331,0,0,1,3,5.259L2.59,5A.732.732,0,0,0,2.2,4.83a1.953,1.953,0,0,0-.722.131,1.735,1.735,0,0,0-.566.355,2.236,2.236,0,0,0-.394.513,3.144,3.144,0,0,0-.261.593A4.99,4.99,0,0,0,.1,7.058,5.928,5.928,0,0,0,.02,7.69C.007,7.881,0,8.08,0,8.28A1.661,1.661,0,0,0,.493,9.536,1.775,1.775,0,0,0,1.764,10H6.579A1.775,1.775,0,0,0,7.85,9.536,1.66,1.66,0,0,0,8.343,8.28C8.343,8.079,8.336,7.88,8.323,7.689Zm0,0",
    fill: "#8e8e8e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.58812ea49599f193c72d7f1fed10a73a.svg";
export { ForwardRef as ReactComponent };